import React from 'react';
import '../styles/dropdown.css';

const MobileDropdown = ({ items, onClose }) => {
  return (
    <ul className="mobile-dropdown open" onClick={onClose}>
      {items.map((item, idx) => (
        <li key={idx}>
          <a href="#">{item}</a>
        </li>
      ))}
    </ul>
  );
};

export default MobileDropdown;
